/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Edit_ButtonInputs */

const en_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Metadata`)
};

const fr_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier les métadonnées`)
};

const de_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten bearbeiten`)
};

const it_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica metadati`)
};

const ru_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать метаданные`)
};

const es_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar metadatos`)
};

const zh_cn2_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑元数据`)
};

const ja_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータの編集`)
};

const hi_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा संपादित करें`)
};

const pt_pt2_event_group_metadata_edit_button = /** @type {(inputs: Event_Group_Metadata_Edit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar metadados`)
};

/**
* | output |
* | --- |
* | "Edit Metadata" |
*
* @param {Event_Group_Metadata_Edit_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_edit_button = /** @type {((inputs?: Event_Group_Metadata_Edit_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Edit_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_edit_button(inputs)
	if (locale === "de") return de_event_group_metadata_edit_button(inputs)
	if (locale === "it") return it_event_group_metadata_edit_button(inputs)
	if (locale === "ru") return ru_event_group_metadata_edit_button(inputs)
	if (locale === "es") return es_event_group_metadata_edit_button(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_edit_button(inputs)
	if (locale === "ja") return ja_event_group_metadata_edit_button(inputs)
	if (locale === "hi") return hi_event_group_metadata_edit_button(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_edit_button(inputs)
	return en_event_group_metadata_edit_button(inputs)
});